/* RHÔME — annonces rotatives + tiroir de navigation */
(function () {
  'use strict';

  function announcements(scope) {
    scope.querySelectorAll('[data-rh-ann]').forEach(function (bar) {
      var slides = bar.querySelectorAll('.rh-ann__slide');
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var delay = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      function go(n) {
        slides[i].classList.remove('is-on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on');
      }
      function auto() { timer = setInterval(function () { go(i + 1); }, delay); }
      var prev = bar.querySelector('.rh-ann__nav--prev');
      var next = bar.querySelector('.rh-ann__nav--next');
      if (prev) prev.addEventListener('click', function () { clearInterval(timer); go(i - 1); auto(); });
      if (next) next.addEventListener('click', function () { clearInterval(timer); go(i + 1); auto(); });
      auto();
    });
  }

  function drawer(scope) {
    var d = scope.querySelector('[data-rh-hdrawer]') || document.querySelector('[data-rh-hdrawer]');
    var s = scope.querySelector('[data-rh-hscrim]') || document.querySelector('[data-rh-hscrim]');
    if (!d || !s) return;
    function close() { d.classList.remove('is-on'); s.classList.remove('is-on'); }
    scope.querySelectorAll('[data-rh-burger]').forEach(function (b) {
      b.addEventListener('click', function () { d.classList.add('is-on'); s.classList.add('is-on'); });
    });
    d.querySelectorAll('[data-rh-closedrawer]').forEach(function (b) { b.addEventListener('click', close); });
    s.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    d.querySelectorAll('[data-rh-dacc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = b.nextElementSibling;
        if (!sub) return;
        sub.classList.toggle('is-on');
        var sign = b.querySelector('i');
        if (sign) sign.textContent = sub.classList.contains('is-on') ? '−' : '+';
      });
    });
  }

  function initAll(scope) { announcements(scope); drawer(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
